import React from 'react';
import PropTypes from 'prop-types';

import { useFormikContext } from 'formik';
import IconArrow from '../../../images/IconArrow';

import Stepper from '../../Stepper';

import {
  Container,
  Content,
  Layout,
  PreviousButton,
  NextButton,
} from './Navigation.styles';

import { useWizard } from '../WizardContext';

const Navigation = ({ larger, onPreviousClick, onNextClick, onStepClick }) => {
  const { isFirstStep, isLastStep } = useWizard();

  const { isSubmitting, isValidating } = useFormikContext();

  return (
    <Container>
      <Content larger={larger}>
        <Layout>
          <PreviousButton
            outlined
            renderIcon={<IconArrow style={{ transform: 'rotate(180deg)' }} />}
            iconFirst
            onClick={onPreviousClick}
            disabled={!!isFirstStep}
          >
            Précédente
          </PreviousButton>

          <div
            css={`
              grid-area: stepper;
            `}
          >
            <Stepper onStepClick={onStepClick} />
          </div>

          <NextButton
            outlined
            primary
            renderIcon={<IconArrow />}
            type='submit'
            disabled={isSubmitting || isValidating}
            loading={isSubmitting || isValidating}
            onClick={onNextClick}
          >
            {isLastStep ? 'Envoyer' : 'Suivante'}
          </NextButton>
        </Layout>
      </Content>
    </Container>
  );
};

Navigation.propTypes = {
  onPreviousClick: PropTypes.func,
  onNextClick: PropTypes.func,
  onStepClick: PropTypes.func,
  larger: PropTypes.bool,
};

Navigation.defaultProps = {
  onPreviousClick: () => {},
  onNextClick: () => {},
  onStepClick: () => {},
  larger: false,
};

export default Navigation;
